import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { LetModule } from '@rx-angular/template';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';

import { CreateUserRequestModalModule } from '../create-user-request-modal/create-user-request-modal.module';
import { SettingsModalModule } from '../settings-modal/settings-modal.module';
import { TranslationTimeModule } from '../translation-time/translation-time.module';
import { LotTranslateRequestCreateModalComponent } from './components/lot-translate-request-create-modal/lot-translate-request-create-modal.component';
import { LotCreateTranslationRequestButtonComponent } from './lot-create-translation-request-button.component';
import { LotTranslationService } from './services/lot-translation.service';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { LotAiTranslationTabComponent } from './components/lot-translate-request-create-modal/components/lot-ai-translation-tab/lot-ai-translation-tab.component';
import { LotManualTranslationTabComponent } from './components/lot-translate-request-create-modal/components/lot-manual-translation-tab/lot-manual-translation-tab.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
  declarations: [
    LotTranslateRequestCreateModalComponent,
    LotCreateTranslationRequestButtonComponent,
    LotAiTranslationTabComponent,
    LotManualTranslationTabComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    LetModule,
    NzFormModule,
    NzAlertModule,
    BrowserModule,
    NzRadioModule,
    NzModalModule,
    NzInputModule,
    NzButtonModule,
    TranslateModule,
    SettingsModalModule,
    ReactiveFormsModule,
    TranslationTimeModule,
    BrowserAnimationsModule,
    CreateUserRequestModalModule,
    NzTabsModule,
    NzSelectModule,
    NzToolTipModule,
  ],
  exports: [LotCreateTranslationRequestButtonComponent],
  providers: [LotTranslationService],
})
export class LotCreateTranslationRequestButtonModule {}
